import * as common from 'store/modules/common'
import { toast } from 'react-toastify'
import { api } from './api'
import { fromUtcString, toUtcDate } from 'utils/dateUtilities'
import { format } from 'utils/stringUtilities'
import { localize } from 'store/modules/localization'
import { orderStatus } from 'enums/orderStatus'

const newEntity = {
  supplier: null,
  dateOfOrder: toUtcDate(new Date()),
  status: 0,
  currency: null,
  exchangeRate: null,
  orderedWines: [],
  dateOfPayment: null,
  paymentType: 1,
  id: 0
}

export const prefix = 'orders'
export { api }
export const initialState = { ...common.initialState, creatingBottles: false }
export const actionTypes = { 
  ...common.actionTypes(prefix),
  creatingBottles: `${prefix}/creatingBottles`,
  bottlesCreated: `${prefix}/bottlesCreated`
}

export const actionCreators = {
  ...common.actionCreators(prefix, api),
  additionalActions: {
    createOrderedBottles: (dto, callback) => (dispatch, getState) => {
      dispatch({ type: actionTypes.creatingBottles, payload: true })
      api.createOrderedBottles(dto)
        .then(response => {
          dispatch({ type: actionTypes.bottlesCreated })
          const notificationText = format(localize(getState().localization, 'ordersProcessing.bottlesCreated'), response)
          toast.info(notificationText)
          if (typeof callback === 'function') { callback(response) }
        })
        .catch(error => common.handleError(prefix, { getState, dispatch, error, update: { creatingBottles: false } }))
    }
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.create: return { ...state, entity: { ...newEntity, isDirty: true } }
    case actionTypes.creatingBottles: return { ...state, creatingBottles: action.payload }
    case actionTypes.bottlesCreated: return { ...state, entity: { ...state.entity, status: orderStatus.sent }, creatingBottles: false }

    default: return common.reducer(state, action, prefix, {
      transformPayload: payload => ({
        ...payload,
        dateOfOrder: fromUtcString(payload.dateOfOrder),
        dateOfPayment: fromUtcString(payload.dateOfPayment)
    })})
  }
}

